import React from 'react'

// TODO: Not hardcode key
const bingKey = 'AqNCnevexy5KeCqjr0i_ODC432TItuqKlKVwRB8hNvwkFQIyI6w0D3iZCiGV9g3F'
let L

class GeocodeMap extends React.Component {
  static propTypes = {
    latitude: React.PropTypes.number,
    longitude: React.PropTypes.number
  }

  /**
   * Set up map when mounting
   */
  componentDidMount () {
    if (!global.document) return // do not render map on server

    L = require('leaflet')
    const BingLayer = require('_/utils/bingLayer')
    L.Icon.Default.imagePath = '/images/'

    const el = React.findDOMNode(this)
    const { longitude, latitude } = this.props
    const latlng = L.latLng(latitude, longitude)

    const bingRoad = new BingLayer(bingKey, { type: 'road' })
    const bingAerial = new BingLayer(bingKey, { type: 'aerial' })
    const bingAerialLabels = new BingLayer(bingKey, { type: 'aerialwithlabels' })

    this.map = L.map(el, {
      minZoom: 2,
      maxZoom: 20,
      center: latlng,
      zoom: 15,
      layers: [ bingRoad ],
      attributionControl: false
    })

    this.map.addControl(L.control.layers({
      Road: bingRoad,
      Hybrid: bingAerialLabels,
      Satellite: bingAerial
    }))

    // Invalidate size for server-side render
    setTimeout(::this.map.invalidateSize, 10)
    this._changeGeocode(latlng)
  }

  componentDidUpdate () {
    this.map.invalidateSize()
  }

  /**
   * Handle changes manually to map from the outside
   * @param  {[type]} nextProps - new properties passed in
   */
  componentWillReceiveProps (nextProps) {
    if (!this.shouldComponentUpdate(nextProps)) return
    const { longitude, latitude } = nextProps
    const latlng = L.latLng(latitude, longitude)
    this._changeGeocode(latlng)
  }

  /**
   * Prevent component from updating is nothing's changed
   */
  shouldComponentUpdate (nextProps) {
    return (
      nextProps.latitude !== this.props.latitude ||
      nextProps.longitude !== this.props.longitude
    )
  }

  /**
   * Cleans up map when unmounting
   */
  componentWillUnmount () {
    if (this.map) this.map.remove()
  }

  /**
   * Renders or unrenders geocode marker based on changes
   * @param  {Number} latlng
   */
  _changeGeocode (latlng) {
    if (this.geocodeMarker) {
      this.map.removeLayer(this.geocodeMarker)
      this.geocodeMarker = null
    }
    this.geocodeMarker = L.marker(latlng)
    this.map.addLayer(this.geocodeMarker)
    this.map.setView(latlng, 15)
  }

  render () {
    return (
      <div className="redi-component-geocode-map" />
    )
  }
}

export default GeocodeMap



// WEBPACK FOOTER //
// ./modules/shared/components/geocodeMap.js